var _defs, _rect, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect2, _text9, _text0, _text1, _text10, _rect3, _text11, _rect4, _text12, _text13, _text14, _text15, _rect5, _text16, _rect6, _text17, _text18, _text19, _text20, _rect7, _text21, _rect8, _text22, _text23, _text24, _text25, _rect9, _text26, _line, _line2, _rect0, _text27, _text28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAgentEscalationLadderMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 620",
    width: 1040,
    height: 620,
    role: "img",
    "aria-label": "Matrix placing AI agent actions on the escalation ladder by reversibility and blast radius: act autonomously, act then notify, act with approval, advise only",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mxBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mxAi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .t   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .cap { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#b8b2cc; }\n      .cell{ font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .ex  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#b8b2cc; }\n      .k   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; }\n      .tag { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#121020; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 620,
    rx: 18,
    fill: "url(#mxBg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 54,
    className: "t",
    fontSize: 26
  }, "Pick the rung: reversibility &#215; blast radius")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 84,
    className: "cap",
    fontSize: 16
  }, "One agent, four gates. The action decides the rung &#8212; not the agent.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90 96 300)",
    x: 96,
    y: 300,
    textAnchor: "middle",
    className: "cap",
    fontSize: 15
  }, "BLAST RADIUS &#8594;")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90 134 420)",
    x: 134,
    y: 420,
    textAnchor: "middle",
    className: "k",
    fontSize: 13,
    opacity: 0.85
  }, "one task")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90 134 180)",
    x: 134,
    y: 180,
    textAnchor: "middle",
    className: "k",
    fontSize: 13,
    opacity: 0.85
  }, "customer-facing")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 534,
    textAnchor: "middle",
    className: "cap",
    fontSize: 15
  }, "REVERSIBILITY &#8594;")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 506,
    className: "k",
    fontSize: 13,
    opacity: 0.85
  }, "one click to undo")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 506,
    textAnchor: "end",
    className: "k",
    fontSize: 13,
    opacity: 0.85
  }, "cannot be undone")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 120,
    width: 405,
    height: 172,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#8f7fd0",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 162,
    className: "cell",
    fontSize: 21
  }, "Act, then notify")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 192,
    className: "ex",
    fontSize: 15
  }, "Wide reach, cheap to reverse. The agent moves,")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 214,
    className: "ex",
    fontSize: 15
  }, "then posts what it did and how to undo it.")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 252,
    className: "k",
    fontSize: 14
  }, "Reschedule a ceremony &#183; rebalance a sprint")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 264,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#8f7fd0"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 239,
    y: 280,
    textAnchor: "middle",
    className: "tag",
    fontSize: 12
  }, "RUNG 3")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 120,
    width: 405,
    height: 172,
    rx: 12,
    fill: "#2b2318",
    stroke: "#e2b24a",
    strokeWidth: 2
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 162,
    className: "cell",
    fontSize: 21
  }, "Advise only")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 192,
    className: "ex",
    fontSize: 15
  }, "Wide reach, no undo. The agent writes the brief")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 214,
    className: "ex",
    fontSize: 15
  }, "and the recommendation. A human takes the action.")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 252,
    className: "k",
    fontSize: 14
  }, "Tell a customer a date slipped &#183; change a contract")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 264,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#e2b24a"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 654,
    y: 280,
    textAnchor: "middle",
    className: "tag",
    fontSize: 12
  }, "RUNG 2")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 300,
    width: 405,
    height: 172,
    rx: 12,
    fill: "#16283a",
    stroke: "#8fd8f0",
    strokeWidth: 2
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 342,
    className: "cell",
    fontSize: 21
  }, "Act autonomously")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 372,
    className: "ex",
    fontSize: 15
  }, "Small reach, cheap to reverse. No gate, full log.")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 394,
    className: "ex",
    fontSize: 15
  }, "Gating here is how you train people to click yes.")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 432,
    className: "k",
    fontSize: 14
  }, "Reassign a task &#183; post a roll-up &#183; nudge a blocker")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 444,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#8fd8f0"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 239,
    y: 460,
    textAnchor: "middle",
    className: "tag",
    fontSize: 12
  }, "RUNG 4")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 300,
    width: 405,
    height: 172,
    rx: 12,
    fill: "#1d1a2e",
    stroke: "#8f7fd0",
    strokeWidth: 2
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 342,
    className: "cell",
    fontSize: 21
  }, "Act with approval")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 372,
    className: "ex",
    fontSize: 15
  }, "Small reach, no undo. One named approver, a")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 394,
    className: "ex",
    fontSize: 15
  }, "deadline, and a default if the deadline passes.")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 611,
    y: 432,
    className: "k",
    fontSize: 14
  }, "Email a customer &#183; close a ticket &#183; spend money")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 611,
    y: 444,
    width: 86,
    height: 22,
    rx: 11,
    fill: "#8f7fd0"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 654,
    y: 460,
    textAnchor: "middle",
    className: "tag",
    fontSize: 12
  }, "RUNG 3")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 120,
    x2: 580,
    y2: 472,
    stroke: "#2a2547",
    strokeWidth: 1.5,
    strokeDasharray: "6 8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 296,
    x2: 990,
    y2: 296,
    stroke: "#2a2547",
    strokeWidth: 1.5,
    strokeDasharray: "6 8"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 552,
    width: 928,
    height: 2,
    fill: "#2a2547"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 586,
    className: "cap",
    fontSize: 15
  }, "Rung 1 (Observe) is not on the grid: every new agent runs in shadow mode first, writing nothing.")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 608,
    className: "k",
    fontSize: 14,
    opacity: 0.9
  }, "BossDrop stores the rung per action type and logs every promotion with who approved it.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAgentEscalationLadderMatrix);
export default __webpack_public_path__ + "static/media/ai-agent-escalation-ladder-matrix.f08507e5a112d8846644e5da54d0ab83.svg";
export { ForwardRef as ReactComponent };